import React from 'react';
import PropTypes from 'prop-types';

import * as RowPage from '@components/common/shroud/row_page';
import UGTDisclaimer from '@components/common/language_menu/ugtDisclaimer';
import { ListDropdown } from '@components/library/dropdown';
import CustomFieldValueRow from './custom_field_value_row';
import {
  getLanguageMapEntryFromSearchString,
  getUgtLocaleSearchString,
} from '../user_generated_translations/bulk_ugt_helpers';

import './styles/main.scss';

class CustomFieldsValueManagement extends React.Component {
  state = {
    visibleValues: this.props.customFieldValues,
    queryString: null,
    sortBy: "name",
    pageSize: this.getPageSize(this.props.customFieldValues)
  }

  getPageSize(updatedValues) {
    return RowPage.getPageSize(Object.keys(updatedValues).length);
  }

  updateSearch = (event) => {
    this.setState({ queryString: event.target.value });
  }

  handleSorting = (selection) => {
    this.setState({ sortBy: selection.value });
  }

  updateValues = (oldValue, newValue) => {
    const data = {
      data: {
        management_action: newValue ? "update" : "delete",
        brandfolder_key: BF.fx.brandfolder().key,
        custom_field_key: this.props.customFieldKey.key,
        old_value: oldValue,
        new_value: newValue,
        bypass_controlled_custom_fields: true
      }
    };
    $.ajax({
      type: 'PUT',
      url: `/api/v4/bulk_actions/assets/manage_custom_fields${getUgtLocaleSearchString()}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      data: JSON.stringify(data),
      context: this,
      success: () => {
        this.updateVisibleValues(oldValue, newValue);
      }
    });
  }

  redirectToAllCustomFields() {
    document.getElementById("custom_fields").click();
  }

  updateVisibleValues(oldValue, newValue) {
    const { visibleValues } = this.state;
    let updatedValues;
    if (newValue) {
      updatedValues = Object.assign(visibleValues, { [newValue]: visibleValues[oldValue] });
    } else {
      updatedValues = Object.assign({}, visibleValues);
    }
    delete updatedValues[oldValue];
    const pageSize = this.getPageSize(updatedValues);
    this.setState({ visibleValues: updatedValues, pageSize });
  }

  queriedValues() {
    const { visibleValues, queryString } = this.state;
    return Object.keys(visibleValues).filter((value) => (
      value.toLowerCase().includes(queryString.toLowerCase())));
  }

  sortedByValue() {
    const { visibleValues, queryString } = this.state;
    const valuesToSort = queryString ? this.queriedValues() : Object.keys(visibleValues);
    return valuesToSort.sort((a, b) => ((a.toLowerCase() < b.toLowerCase()) ? -1 : 1));
  }

  sortedByCount() {
    const { visibleValues, queryString } = this.state;
    const valuesToSort = queryString ? this.queriedValues() : Object.keys(visibleValues);
    return valuesToSort.sort((a, b) => ((visibleValues[a] < visibleValues[b]) ? 1 : -1));
  }

  sortedValues() {
    const { sortBy } = this.state;
    if (sortBy === "count") {
      return this.sortedByCount();
    }
    return this.sortedByValue();
  }

  renderSortingOptions() {
    return (
      <div className="sorting-options">
        <input
          className="bf-input searchbar"
          id="custom-field-values-search"
          onChange={this.updateSearch}
          placeholder={`Search ${Object.keys(this.props.customFieldValues).length} custom field values`}
          type="text"
        />
        <div className="sort-options">
          <div><p>{bfTranslate('Sort by')}:</p></div>
          <ListDropdown
            className="custom-field-key-sorting"
            closeOnSelect
            isSearchable={false}
            onChange={this.handleSorting}
            options={[
              { value: "name", label: bfTranslate("Name") },
              { value: "count", label: bfTranslate("Count") }
            ]}
            placeholder={bfTranslate('Name')}
            value={this.state.sortBy}
            virtualizeOptions={false}
          />
        </div>
      </div>
    );
  }

  renderNoCustomFields() {
    const { customFieldKey } = this.props;
    return (
      <div className="manage-custom-fields">
        {`${customFieldKey.name} ${bfTranslate('does not have any custom values')}.`}
      </div>
    );
  }

  renderRows(pageIndex) {
    const pageKeys = RowPage.getPageSlice(pageIndex, this.state.pageSize, this.sortedValues());
    return pageKeys.map((value) => (
      <div key={value} className="custom-field-value-row">
        <CustomFieldValueRow
          count={this.props.customFieldValues[value]}
          customFieldKey={this.props.customFieldKey}
          updateValues={this.updateValues}
          value={value}
        />
      </div>
    ));
  }

  renderPages() {
    const { pageSize } = this.state;
    const renderedPages = [];
    const numPages = RowPage.getNumPages(pageSize, this.sortedValues().length);
    for (let pageIndex = 0; pageIndex < numPages; pageIndex += 1) {
      renderedPages.push(
        <RowPage.RowPage
          key={`custom-field-values-row-page-${pageIndex}`}
          isInitialPage={pageIndex === 0}
          pageSize={pageSize}
          renderRows={() => this.renderRows(pageIndex)}
        />
      );
    }
    return renderedPages;
  }

  render() {
    const { customFieldKey } = this.props;
    if (this.props.customFieldValues.length < 1) {
      return this.renderNoCustomFields();
    }
    return (
      <div className="manage-custom-field-values">
        <UGTDisclaimer getSelectedLanguage={getLanguageMapEntryFromSearchString} />
        <h2>{bfTranslate("Custom Field Values for")} {customFieldKey.name}</h2>
        <hr />
        <span className="redirect" onClick={this.redirectToAllCustomFields}>
          Custom Fields
        </span>
        <span className="selected-key">
          {` / ${customFieldKey.name}`}
        </span>
        {this.renderSortingOptions()}
        <div className="custom-fields-list">
          <div className="headers">
            <div className="headers-container">
              <h3 className="quarter-width">{bfTranslate('Key')}</h3>
              <h3 className="twenty-width">{bfTranslate('Values')}</h3>
              <h3 className="twenty-width"># {bfTranslate('Assets')}</h3>
            </div>
          </div>
          { this.renderPages() }
        </div>
      </div>
    );
  }
}

CustomFieldsValueManagement.propTypes = {
  customFieldKey: PropTypes.shape({
    name: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
  customFieldValues: PropTypes.objectOf(PropTypes.number).isRequired
};

export default CustomFieldsValueManagement;
